export default "__VITE_ASSET__CA8gH3nr__"